export interface ILicensePlateLookupOptions {
  LicensePlateFieldName: string;
  showButton: boolean;
  overrideExistingValues: boolean;
  fieldValueMaps: ILicensePlateLookupValueMap[];
}

export interface ILicensePlateLookupValueMap {
  modelFieldName: string;
  lookupFieldName: string;
  lookupFieldType: LicensePlateLookupValueFieldType;
  codeTranslations?: ILookupCodeTranslation[];
}

export interface ILookupCodeTranslation {
  lookupValue: string;
  outputValue: string;
}

export enum LicensePlateLookupValueFieldType {
  Code = "code",
  Description = "description"
}
